import React from "react"
import { Navigate, useLocation } from "react-router-dom"
import { Box, IconButton, Tooltip } from "@mui/material"
import { IconSeeker } from "@ui-seeker/core"
import { MaximalLayout } from "@app"

import { useUserApp } from "@hooks"
import { isLocal, isUserMaster, userData } from "@signals"
import { SESSIONS_ROUTES } from "@constants"
import { dsColorNew } from "@palette"
import { appConfig, styles } from "./config"
import routes from "../Routes"
import SlavesAutocomplete from "Layout/Slaves"
import PmsAgentWidget from "Layout/PmsAgentWidget"
import SupportChatButton from "Layout/SupportChat"


function HeaderTools() {
	return <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
		{isUserMaster.value && <SlavesAutocomplete/>}
		<Tooltip title="User Guide" arrow>
			<IconButton
				size="small"
				onClick={() => {
					const guide = navigator.language?.startsWith('es') ? '/assets/user-guide-es.html' : '/assets/user-guide.html'
					window.open(guide, '_blank')
				}}
				sx={{
					color: dsColorNew.textMuted,
					'&:hover': { color: dsColorNew.webBlue500, bgcolor: dsColorNew.hoverBgLight },
				}}
			>
				<IconSeeker icon="book-open" sx={{ fontSize: 16 }}/>
			</IconButton>
		</Tooltip>
		<SupportChatButton/>
	</Box>
}


export default function AppLayout() {
	const { pathname, search } = useLocation()
	const { isLogged } = useUserApp(true)
	const renderRoutes = routes(userData.value).filter(r => !r.noRender && (userData?.value?.featuresV2 && userData?.value?.featuresV2[r.id]))

	if (!isLogged) return <Navigate
		to={`${SESSIONS_ROUTES.LOGIN_URL}?redirect=${pathname}${search}`}
		replace
	/>

	return <>
		<PmsAgentWidget/>
		<MaximalLayout
			userData={userData.value}
			routes={renderRoutes}
			config={appConfig}
			isLocal={isLocal.value}
			components={{ headerTools: <HeaderTools/> }}
			styles={styles}
		/>
	</>
}